import { render } from "./moh510.vue?vue&type=template&id=5580a1a1&scoped=true"
import script from "./moh510.vue?vue&type=script&lang=js"
export * from "./moh510.vue?vue&type=script&lang=js"

import "./moh510.vue?vue&type=style&index=0&id=5580a1a1&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5580a1a1"]])

export default __exports__